import CartDiscounts from '../../cart/CartDiscounts.react';
import PopupActions from '../../../../actions/PopupActions';
import FeeDonationItem from './FeeDonationItem.react';

class FeeDonation extends React.Component {

    render() {
        var self                 = this;
        var appliedFeesDonations = this.props.appliedFeesDonations;
        var data                 = false;
        var guest                = this.props.guest;

        return (
            <div className='pos-sidebar__content'>

                <div className='container'>
                    <div className='row mb-4 mt-1'>
                        <div className='pos-sidebar__title col-10'>
                            Fees &amp; Donations
                        </div>
                        
                        <div
                            className={'increase__btn col'}
                            onClick={() => { PopupActions.open('fee-donation', data, guest)}}>
                            <i className='fa fa-plus' aria-hidden='true' /> 
                        </div>
                    </div>
                </div>

                { appliedFeesDonations.map(fd => {
                    return (
                        <FeeDonationItem
                            fd={fd}
                            guest={guest}/>
                    );
                })}

            </div>
        );
    }
}

export default FeeDonation;


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/sidebar/feesDonations/FeeDonation.react.jsx